module.exports = __webpack_public_path__ + "img/jugong.89ea0d5f.gif";